import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/app/(site)/updates/components/update/index.tsx");
